module.exports = __webpack_public_path__ + "f7b936863faca7c046f91b04d778efde.pdf";